import axios from '../helper/axios';
import { projectConstants } from './constants';

export const getProjects = () => async (dispatch) => {
  try {
    dispatch({ type: projectConstants.GET_PROJECT_REQUEST });

    const res = await axios.get('/projects/');

    if (res.status === 200) {
      dispatch({
        type: projectConstants.GET_PROJECT_SUCCESS,
        payload: res.data.projects,
      });
    }
  } catch (err) {
    dispatch({
      type: projectConstants.GET_PROJECT_FAILURE,
      payload: err.message,
    });
  }
};
